module.exports = __webpack_public_path__ + "files/b8bf891a72501dea8fc1f478206ea5a6.png";